import styled, { css } from 'styled-components';
import { media, layout } from 'src/components/base';
import { Card as CardComponent } from '@prisjakt/ui/card';

type ColumnProps = {
  expand?: boolean;
};

export const Column = styled.div<ColumnProps>(
  props => css`
    display: flex;
    align-items: stretch;

    ${props.expand &&
      css`
        flex: 2;
      `}
  `
);

type SharedRowProps = {
  hoverEnabled?: boolean;
  $featured?: boolean;
  $forceMobileView?: boolean;
  $kebab?: boolean;
  $noExternalUri?: boolean;
  $showCleanOfferExperiment?: boolean;
};

const rowStyles = css`
  line-height: 1.3em;
  position: relative;

  ${(props: SharedRowProps) =>
    props.$noExternalUri &&
    css`
      cursor: default;
    `}

  ${props =>
    !props.$featured &&
    css`
      color: ${props.theme.text.secondary};
      &:hover {
        color: ${props.theme.text.secondary};
      }
      background: ${props.theme.colors.base100};
    `}
`;

type RowExperimentProps = {
  $expanded?: boolean;
  $isAlternative?: boolean;
  $hasAuthorizedDealer?: boolean;
};

export const RowCard = styled(CardComponent)<
  SharedRowProps & RowExperimentProps
>(
  props => css`
    ${rowStyles}

    background-color: ${props.theme.colors.base100};

    flex: 1;


    ${props.$isAlternative &&
      css`
        border-radius: 0;

        :first-child {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }

        :last-child {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
        }
      `};

    ${!props.$featured &&
      css`
        box-shadow: none;
      `}
  `
);

export const Row = styled.div<SharedRowProps & RowExperimentProps>(
  props => css`
    ${rowStyles};
    border-radius: inherit;
    display: flex;
    align-items: stretch;
    background: ${props.theme.bg.primary};

    ${!props.$featured &&
      !props.$isAlternative &&
      css`
        background: none;
        height: 54px;
      `}

    ${props.$expanded &&
      css`
        border-bottom: 1px solid ${props.theme.colors.base200};
      `}

    ${props.$isAlternative &&
      !props.$featured &&
      css`
        background: none;
        border: none;
      `}
  `
);

export const AltReportRow = styled.div`
  ${rowStyles}
  background-color: rgba(0, 0, 0, 0.03);
  padding: 0 ${layout.measurements.spacing100};
  border-bottom: 1px solid ${props => props.theme.colors.base200};

  ${media.smallOnly`
    padding: ${layout.measurements.spacing050};
    border: none;
  `}
`;
